<!-- /dashboard/kidqueue
queue dashboard
usher page -->

<template>
  <div class="wrapper">
    <CRow>
      <CCol>
        <div class="card">
          <div class="card-body">
            <CRow>
              <CCol lg="4" >
                <div id="app">
                  <Crow>
                    <CCol>
                      <h5>{{currentDate()}}</h5>
                      </CCol>
                      <CCol>
                      <h3> {{ showTime }} </h3>
                      </CCol>
                  </Crow>
                  </div>
              </CCol>
              <CCol class="d-flex justify-content-center" lg="4" >
                  <h3>Queue Dashboard ( {{ meta.total }} ) </h3>
              </CCol>
            </CRow>
          </div>
        </div>
      </CCol>
    </CRow>
    <Crow>
      <CCol  class="d-flex justify-content-start">
        <Datatable
          @search="handleSearch"
          @checkout="handleCheckOut"
          @forceCheckout="handleForceCheckOut"
          @cancelStatus="handleCancelStatus"
          @forceCancelStatus="handleForceCancelStatus"
      />
      </CCol>
    </Crow>
    <CRow class="mt-3">
          <CCol lg="4" v-for="item in items" :key="item.id" >
            <CCol  >
              <CCard class="card" v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'">
                <CRow>
                  <CCol>
                    <CCardBody>
                      <CRow>
                        <img v-bind:src="getPhoto(item.get_photo)" class="c-avatar-img-scan justify-content-start">
                          <CCol>
                            <CCallout v-if="item.checkin_status == null" color="secondary">
                          <row >
                            <h5><CBadge v-if="item.checkin_status == null" color="secondary">Unconfirmed</CBadge></h5>
                            <p> Name: <b> {{item.name}} </b></p>
                            <p> Class: <b>{{item.class_name}} </b> </p>
                            <p> Date Of Birth: <b>{{item.dob}} </b> </p>
                          </row>
                        </CCallout>
                        <CCallout v-else="item.checkin_status !== null && item.checkin_status.action == 'check out'" color="danger">
                          <row >
                            <h5><CBadge v-if="item.checkin_status !== null && item.checkin_status.action == 'check out'" color="danger">Check out</CBadge></h5>
                            <p> Name: <b> {{item.name}} </b></p>
                            <p> Class: <b>{{item.class_name}} </b> </p>
                            <p> Date Of Birth: <b>{{item.dob}} </b> </p>
                          </row>
                        </CCallout>
                          <CButton
                            v-if="item.checkin_status !== null && item.checkin_status.action == 'queued'"
                            block
                            :disabled="isActionLoading(item.id)"
                            @click="openCheckOut(item.id)"
                            variant="primary"
                            color="danger"
                          >{{ isActionLoading(item.id) ? 'Loading...' : 'Check Out' }}</CButton>
                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" block @click=" openForceCheckOut(item.id)"  variant="primary" color="danger">Check Out</CButton> -->
                          <!-- <CButton  v-if="item.checkin_status !== null && item.checkin_status.action == 'in class'" block @click=" openForceCancelStatus(item.id,2)"  variant="outline" color="secondary">Cancel</CButton> -->
                      </CCol>
                    </CRow>
                  </CCardBody>
                </CCol>
              </CRow>
            </CCard>
          </CCol>
        </CCol>
    </CRow>
      <ikidmodal_checkin></ikidmodal_checkin>
      <alertmodal></alertmodal>
  </div>
</template>

<script >
import Datatable from '@/components/datatables_ikid_queue.vue'
import DatatableClass from '@/components/datatables_ikid_check_class.vue'
import DatatableLog from '@/components/datatables_ikid_check_log.vue'

import axios from 'axios'

import ikid from '@/services/ikid_v2'
import ikidmodal_checkin from './ikidsmodal_checkin.vue';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

import Pusher from 'pusher-js'
import Vue from 'vue'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const token = localStorage.getItem('token');

export default {
  name: 'iKidsTable',
  components: { ikidmodal_checkin, alertmodal, Datatable,DatatableClass,DatatableLog },
  data(){
    return{
      form:{
        ikid_id:'',
        status:'',
        from:'portal',
      },
      showMilitary: false,
      showTime: '',
      now: new Date(),
      updateSubmit: false,
      largeModal:false,
      datas:[],
      fields: [
          {key: 'name', sortable: false, },
          {key: 'profilepic', sortable: false, },
          {key: 'class_name', sortable: false, },
          {key: 'dob', sortable: false, },
          {key: 'checkin_status', label:'Status', sortable: false, },
          {key: 'action', label: 'Action', sortable: false},
      ],
      rawItems: [],
      items: [],
      meta: [],
      metaLog: [],
      current_page: 1,
      per_page: 200,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      permission: true,
      ikid_class_name:  '',
      checkin_status: 3,
      pusher_data: {
        kid_name: null,
        kid_class_id: null,
        now_action: null,
        from: null,
      },
      refreshTimer: null,
      refreshQueued: false,
      refreshInFlight: false,
      refreshLastRunAt: 0,
      baseRefreshIntervalMs: 2500,
      burstRefreshIntervalMs: 1000,
      burstUntilTs: 0,
      heartbeatIntervalMs: 3000,
      heartbeatTimer: null,
      tableUpdateHandler: null,
      pusherClient: null,
      lastEventId: null,
      actionLoadingByKidId: {},
    }
  },

  created() {
      this.beforeDestroy()
  },

  mounted (){
    this.loadData()
    this.tableUpdateHandler = (data) => {
      if(data){
          this.queueRealtimeRefresh();
      }
    }
    EventBus.$on('TABLE_UPDATE_USHER_PAGE', this.tableUpdateHandler)
    this.showTheTime()

    Vue.use(Toast)
    this.heartbeatTimer = setInterval(() => {
      this.queueRealtimeRefresh()
    }, this.heartbeatIntervalMs)

    this.pusherClient = new Pusher('fbb60f501f4a91119030', {
      cluster: 'ap1',
      encrypted: true
    })
    const channel = this.pusherClient.subscribe('ikids-v2')
    channel.bind('status-changed', (data) => {
      const eventId = Number(data && data.event_id)
      if (!Number.isNaN(eventId) && this.lastEventId && eventId <= Number(this.lastEventId)) {
        return
      }

      const prevStatus = Number(data && data.prev_status)
      const newStatus = Number(data && data.new_status)
      const isQueueRelated = prevStatus === 3 || newStatus === 3
      if (!isQueueRelated) return

      this.activateRealtimeBurst()
      this.queueRealtimeRefresh()
    })

   },

  beforeDestroy() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
      this.refreshTimer = null
    }
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
    if (this.tableUpdateHandler) {
      EventBus.$off('TABLE_UPDATE_USHER_PAGE', this.tableUpdateHandler)
      this.tableUpdateHandler = null
    }
    if (this.pusherClient) {
      this.pusherClient.disconnect()
      this.pusherClient = null
    }
  },

  methods: {
    beforeDestroy(){
    EventBus.$off('OPEN_MODAL_IKID_CHECKIN', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_QUEUE', this.listener)
    EventBus.$off('OPEN_MODAL_IKID_CHECKOUT', this.listener)
   },

   currentDate() {
    var  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      const current = new Date();
      const date = current.getDate() +' '+ months[current.getMonth()]+' '+current.getFullYear()
      return date;
    },

   showTheHours(theHour) {
      var vm = this
      if (vm.showMilitary|| (theHour > 0 && theHour < 13)) {
        if (theHour == "") theHour = 12;
        return (theHour);
      }
      if (theHour == 0) {
        return (12);
      }
      return (theHour);
    },

    showZeroFilled(inValue) {
      if (inValue > 9) {
        return "" + inValue;
      }
      return "0" + inValue;
    },

    showAmPm() {
      var vm = this
      if (vm.showMilitary) {
        return ("");
      }
      if (vm.now.getHours() < 12) {
        return (" AM");
      }
      return (" PM");
    },

    showTheTime() {
      var vm = this
      vm.now = new Date
      vm.showTime = vm.showTheHours(vm.now.getHours()) + ":" + vm.showZeroFilled(vm.now.getMinutes()) + ":" + vm.showZeroFilled(vm.now.getSeconds()) + vm.showAmPm()
      setTimeout(vm.showTheTime,1000)
    },

    openCheckOut: function(uuid) {
      // if(confirm("Do you really want to checkout?")){
        if (this.isActionLoading(uuid)) return
        this.setActionLoading(uuid, true)
        this.form.ikid_id = uuid;
        this.form.status = 4;
        this.activateRealtimeBurst()
        ikid.changeStatusKidQueue(this.form)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_USHER_PAGE', true)
          this.loadData({ useEventGuard: false })
          // var params = {title: 'Success', mode:'success', data:res.message}
          // EventBus.$emit('OPEN_MODAL_ALERT', params)

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).finally(() => {
          this.setActionLoading(uuid, false)
        })
      // }
    },

    openForceCheckOut: function(uuid) {
      // if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = 3;
        this.activateRealtimeBurst()
        ikid.changeStatusKidQueue(this.form)
        .then(res => {

          setTimeout(() => {
            this.form.ikid_id = uuid;
            this.form.status = 4;
            ikid.changeStatusKidQueue(this.form)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE_USHER_PAGE', true)
              this.loadData({ useEventGuard: false })
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }, 1000);


        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      // }
    },

    openCancelStatus: function(uuid, stat) {
      if(confirm("Do you really want to change?")){
        if (this.isActionLoading(uuid)) return
        this.setActionLoading(uuid, true)
        this.form.ikid_id = uuid;
        this.form.status = stat;
        this.activateRealtimeBurst()
        ikid.cancelStatusKidQueue(this.form)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE_USHER_PAGE', true)
          this.loadData({ useEventGuard: false })
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).finally(() => {
          this.setActionLoading(uuid, false)
        })
      }
    },

    openForceCancelStatus: function(uuid, stat) {
      if(confirm("Do you really want to change?")){
        this.form.ikid_id = uuid;
        this.form.status = stat;
        this.activateRealtimeBurst()
        ikid.cancelStatusKidQueue(this.form)
        .then(res => {

          setTimeout(() => {
            this.form.ikid_id = uuid;
            this.form.status = stat-1;
            ikid.cancelStatusKidQueue(this.form)
            .then(res => {
              EventBus.$emit('TABLE_UPDATE_USHER_PAGE', true)
              this.loadData({ useEventGuard: false })
              var params = {title: 'Success', mode:'success', data:res.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            }).catch ((err) => {
              var params = {title: 'Error', mode:'danger', data:err.response.data.message}
              EventBus.$emit('OPEN_MODAL_ALERT', params)
            })
          }, 1000);

        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
    },

    loadData(options = {}) {
      const useEventGuard = options.useEventGuard !== false
      const params = {
        limit: this.per_page,
      }
      if (useEventGuard && this.lastEventId) {
        params.if_modified_since_event_id = this.lastEventId
        params.use_delta = 1
      }

      ikid.getIkidQueue(params)
      .then(res => {
          if (res.not_changed) {
            this.lastEventId = res.event_id || this.lastEventId
            this.applyLocalFilters()
            return
          }
          this.lastEventId = res.event_id || this.lastEventId
          if (res.delta) {
            this.applyDeltaChanges(res.changed_items || [], res.removed_ids || [])
            this.applyLocalFilters()
            return
          }
          this.rawItems = Array.isArray(res.data) ? res.data : []
          this.applyLocalFilters()
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    applyLocalFilters() {
      let filtered = Array.isArray(this.rawItems) ? [...this.rawItems] : []

      if (this.search && this.search.trim() !== '') {
        const query = this.search.toLowerCase()
        filtered = filtered.filter(item => {
          const name = (item.name || '').toLowerCase()
          const className = (item.class_name || '').toLowerCase()
          return name.includes(query) || className.includes(query)
        })
      }

      filtered.sort((a, b) => {
        const timeA = a && a.checkin_status && a.checkin_status.log_time ? new Date(a.checkin_status.log_time).getTime() : 0
        const timeB = b && b.checkin_status && b.checkin_status.log_time ? new Date(b.checkin_status.log_time).getTime() : 0
        return timeA - timeB
      })

      this.items = filtered
      this.meta = {
          total: filtered.length,
          current_page: 1,
          per_page: this.per_page,
          from: filtered.length > 0 ? 1 : 0,
          to: filtered.length,
          is_active: this.is_active,
          ikid_class_name: this.ikid_class_name,
          checkin_status: this.checkin_status
      }
    },
    applyDeltaChanges(changedItems, removedIds) {
      const map = new Map((this.rawItems || []).map(item => [Number(item.id), item]))

      if (Array.isArray(removedIds)) {
        removedIds.forEach((id) => map.delete(Number(id)))
      }

      if (Array.isArray(changedItems)) {
        changedItems.forEach((item) => {
          map.set(Number(item.id), item)
        })
      }

      this.rawItems = Array.from(map.values())
    },
    isActionLoading(kidId) {
      return !!this.actionLoadingByKidId[String(kidId)]
    },
    setActionLoading(kidId, isLoading) {
      const key = String(kidId)
      if (isLoading) {
        this.$set(this.actionLoadingByKidId, key, true)
        return
      }
      this.$delete(this.actionLoadingByKidId, key)
    },
    activateRealtimeBurst(durationMs = 12000) {
      const nextUntil = Date.now() + durationMs
      this.burstUntilTs = Math.max(this.burstUntilTs || 0, nextUntil)
    },
    getCurrentRefreshIntervalMs() {
      return Date.now() < (this.burstUntilTs || 0)
        ? this.burstRefreshIntervalMs
        : this.baseRefreshIntervalMs
    },
    queueRealtimeRefresh() {
      this.refreshQueued = true
      this.flushRealtimeRefresh()
    },
    flushRealtimeRefresh() {
      if (!this.refreshQueued || this.refreshInFlight || this.refreshTimer) return
      const elapsed = Date.now() - this.refreshLastRunAt
      const waitMs = Math.max(0, this.getCurrentRefreshIntervalMs() - elapsed)

      this.refreshTimer = setTimeout(async () => {
        this.refreshTimer = null
        if (!this.refreshQueued || this.refreshInFlight) return
        this.refreshQueued = false
        this.refreshInFlight = true
        this.refreshLastRunAt = Date.now()
        try {
          await this.loadData()
        } finally {
          this.refreshInFlight = false
          if (this.refreshQueued) this.flushRealtimeRefresh()
        }
      }, waitMs)
    },
    getPhoto(data) {
       if (data) {
         return axios.defaults.baseURL + "/getfile/memberphoto/" + data.filename;
       } else {
         return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
       }
     },

    handlePerPage(val) {
        this.per_page = val
        this.loadData({ useEventGuard: false })
    },

    handlePagination(val) {
        this.current_page = val
        this.loadData({ useEventGuard: false })
    },

    handlePerPageLog(val) {
        this.per_pageLog = val
        this.loadData({ useEventGuard: false })
    },

    handlePaginationLog(val) {
        this.current_pageLog = val
        this.loadData({ useEventGuard: false })
    },

    handleSearch(val) {
        this.search = val
        this.current_page = 1
        this.applyLocalFilters()
    },

    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByLog = val.sortBy
        this.sortByDesc = val.sortDesc
        this.sortByDescLog = val.sortDesc
        this.applyLocalFilters()
    },

    handleIsActive(val) {
        this.is_active = val
        this.applyLocalFilters()
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleCheckin(val,ikid_id) {
        this.openCheckin(val,ikid_id)
    },
    handlePresent(val,ikid_id) {
        this.openPresent(val,ikid_id)
    },
    handleInclass(val,ikid_id) {
        this.openInclass(val,ikid_id)
    },
    handleQueue(val,ikid_id) {
        this.openQueue(val,ikid_id)
    },
    handleCheckOut(val,ikid_id) {
        this.openCheckOut(val,ikid_id)
    },
    handleForceCheckOut(val,ikid_id) {
        this.openForceCheckOut(val,ikid_id)
    },
    handleCancelStatus(val,stat) {
        this.openCancelStatus(val,stat)
    },
    handleForceCancelStatus(val,stat) {
        this.openForceCancelStatus(val,stat)
    },
    handleReactivate(val) {
        this.deactivate(val)
    },

  }
}
</script>
